import axios from '@/libs/api.request'
// 获取批量信息
export const getList = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/index',
    method: 'get',
    data
  })
}
// 获取单个信息
export const getDetails = (params) => {
  return axios.request({
    url: `/finance/section/hq/bill/detail/${params.id}`,
    method: 'GET',
    params
  })
}
// 删除单个信息
export const del = (id) => {
  // return axios.request({
  //   url: `/finance/dblChargingType/${id}`,
  //   method: 'DELETE'
  // })
}
// 修改单个信息
export const update = (data) => {
  return axios.request({
    url: `/finance/section/hq/bill/update/${data.id}`,
    method: 'PUT',
    data
  })
}
// 新增单个信息
export const add = (data) => {
  // return axios.request({
  //   url: '/finance/dblChargingType',
  //   method: 'POST',
  //   data
  // })
}

export const recalculate = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/recalculate',
    method: 'POST',
    data
  })
}

export const sync = (params) => {
  return axios.request({
    url: `/finance/section/hq/detail/sync`,
    method: 'GET',
    params
  })
}

export const createBill = (data) => {
  return axios.request({
    url: '/finance/section/hq/detail/createBill',
    method: 'POST',
    data
  })
}

export const append = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/append/' + data.id,
    method: 'POST',
    data
  })
}

export const confirm = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/confirm',
    method: 'POST',
    data
  })
}

export const cancelConfirm = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/cancelConfirm',
    method: 'POST',
    data
  })
}
export const deleteBill = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/deleteBill',
    method: 'DELETE',
    data
  })
}

export const saveRates = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/saveRates',
    method: 'POST',
    data
  })
}

export const getRates = (params) => {
  return axios.request({
    url: `/finance/section/hq/bill/getRates`,
    method: 'GET',
    params
  })
}
export const getConfig = (params) => {
  return axios.request({
    url: `/finance/section/hq/bill/config`,
    method: 'GET',
    params
  })
}

export const getWriteOffData = (params) => {
  return axios.request({
    url: `/finance/section/hq/bill/getWriteOffData`,
    method: 'GET',
    params
  })
}

export const writeOff = (data) => {
  return axios.request({
    url: '/finance/section/hq/bill/writeOff',
    method: 'POST',
    data
  })
}

export const setException = data => {
  return axios.request({
    url: `/finance/section/hq/bill/setException/${data.id}`,
    method: "POST",
    data
  });
};
export const removeDetail = data => {
  return axios.request({
    url: `/finance/section/hq/bill/removeDetail/${data.id}`,
    method: "POST",
    data
  });
};